import UpcomingEventsList from "../widgets/UpcomingEventsList.svelte";

const app = new UpcomingEventsList({
  target: document.getElementById("tf-widget-upcoming-events-list"),
});

export default app;
